// src/components/lists/ListTableShell.tsx
import React from "react";
import clsx from "clsx";

import { A } from "../../styles/appleClasses";

export type ListTableShellProps = React.HTMLAttributes<HTMLDivElement> & {
  maxWidthClass?: string;
  outerClassName?: string;
  innerClassName?: string;
};

export default function ListTableShell({
  maxWidthClass = "max-w-6xl",
  outerClassName = "",
  innerClassName = "",
  className,
  children,
  ...props
}: ListTableShellProps) {
  return (
    <div
      {...props}
      className={clsx(
        "hidden md:block w-full mx-auto px-2 mt-3",
        maxWidthClass,
        outerClassName,
      )}
    >
      <div className={clsx(A.card, "overflow-hidden", innerClassName)}>
        <div className={clsx("overflow-x-auto", className)}>{children}</div>
      </div>
    </div>
  );
}